import styled from "@emotion/styled";

export const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  border: none;

  padding: 12px 16px;

  background-color: ${p => p.theme.colors.white};
  border-radius: 12px;
  row-gap: 12px;
  transition:
    outline-color 0.3s ease,
    color 0.3s ease;
  outline: 2px solid transparent;

  :hover,
  :focus {
    outline-color: ${p => p.theme.colors.accent.green};
  }
`;

export const Title = styled.span`
  margin-right: 12px;
`;
